import React from 'react';
import SuccessfulNotificationComponent from '../Component/SuccessfulNotificationComponent';

export default function SuccessfulNotificationContainer() {
  return <SuccessfulNotificationComponent />;
}
